import reactModule from './utils/react-module';

export default [
  {
    name: 'header',
    loader: () => import('./modules/header')
  },
  {
    name: 'chat',
    loader: () => import('./modules/chat')
  },
  {
    name: 'toggle',
    loader: () => import('./modules/toggle')
  },
  {
    name: 'testimonials',
    loader: () => import('./modules/testimonials')
  },
  {
    name: 'contact',
    loader: () => import('./modules/contact')
  },
  {
    name: 'profileDetail',
    loader: () => import('./modules/profile-detail')
  },
  {
    name: 'video',
    loader: () => import('./modules/video')
  },
  {
    name: 'account',
    loader: () => import('./modules/account')
  },
  {
    name: 'articleListing',
    loader: () => import('./modules/article-listing'),
    render: reactModule
  },
  {
    name: 'eventListing',
    loader: () => import('./modules/event-listing'),
    render: reactModule
  },
  {
    name: 'partnerResources',
    loader: () => import('./modules/partner-resources'),
    render: reactModule
  },
  {
    name: 'searchResults',
    loader: () => import('./modules/search-results'),
    render: reactModule
  },
  {
    name: 'register',
    loader: () => import('./modules/register')
  },
  {
    name: 'tabs',
    loader: () => import('./modules/tabs')
  },
  {
    name: 'rating',
    loader: () => import('./modules/rating')
  },
  {
    name: 'copyLink',
    loader: () => import('./modules/copyLink')
  },
  {
    name: 'popup',
    loader: () => import('./modules/popup')
  }
];
